import React from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { SectionHeader } from '../ui-x';
import { sectionFor } from '../Layouts/navItems';

type Props = {
  title: string;
  description?: ReactNode;
  eyebrow?: string;
  actions?: ReactNode;
  className?: string;
};

/**
 * The page opener. Delegates to ui-x SectionHeader (reference rule 5: every
 * page opens with one), so the 12 call sites keep their `title`/`description`
 * API unchanged.
 *
 * The eyebrow defaults to the rail group the page sits in, which is the same
 * label the sticky header shows — the reference's signature orange tic, for
 * free on every page.
 *
 * This is .tsx rather than .jsx on purpose: untyped JS params are inferred as
 * REQUIRED at .tsx call sites, and defaulting them to `undefined` narrows the
 * type to `undefined`. Declaring the props is the only version that holds.
 */
const PageIntro = ({
  title,
  description,
  eyebrow,
  actions,
  className,
}: Props) => {
  const location = useLocation();

  return (
    <SectionHeader
      eyebrow={eyebrow ?? sectionFor(location.pathname)}
      title={title}
      description={description as string | undefined}
      actions={actions}
      className={className}
    />
  );
};

export default PageIntro;
